import React from 'react';
import { motion } from 'framer-motion';
import { FaDatabase, FaBrain, FaLaptopCode } from 'react-icons/fa';
import { AppWrap, MotionWrap } from '../../wrapper';
import './WhatIDo.scss';

const WhatIDo = () => {
  const services = [
    {
      title: 'Data Engineering',
      icon: <FaDatabase size={32} />,
      description: 'Designing and building robust, scalable data pipelines, ETL/ELT processes, and orchestrating complex workflows. Expert in constructing efficient data architectures that power real time analytics.',
      color: '#38bdf8',
    },
    {
      title: 'AI Engineering & MLOps',
      icon: <FaBrain size={32} />,
      description: 'Integrating GenAI, Agents and LLMs, deploying ML systems into production, and establishing end-to-end MLOps lifecycles from automated validation to continuous monitoring.',
      color: '#a855f7',
    },
    {
      title: 'Software Engineering',
      icon: <FaLaptopCode size={32} />,
      description: 'Crafting reliable, scalable and high-performance software systems, microservices, and specialized CLI tools. Focused on modern design patterns, modular architecture, and system optimization.',
      color: '#f43f5e',
    },
  ];

  return (
    <>
      <h2 style={{ color: 'var(--primary-color)' }}>What I Do</h2>

      <div className="app__services-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="app__service-card app__flex"
            whileInView={{ opacity: [0, 1], y: [40, 0] }}
            transition={{ duration: 0.45, delay: index * 0.15 }}
          >
            <div 
              className="app__service-icon app__flex"
              style={{ 
                color: service.color,
                backgroundColor: `${service.color}15`, // subtle opacity background
                border: `1.5px solid ${service.color}35`
              }}
            >
              {service.icon}
            </div>
            <h3>{service.title}</h3>
            <p className="p-text">{service.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(WhatIDo, 'app__services'),
  'services',
  'app__whitebg',
);
